var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorfilter_main"},[_vm._v("\nCor\n"),_c('hr'),_vm._v(" "),_c('div',{staticClass:"colorfilter"},_vm._l((_vm.colors),function(m){return _c('Color',{key:m.ident,attrs:{"info":m}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-734f739d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorFilter.vue
// module id = null
// module chunks = 